import { reportRepositoryList } from './report-repository-list/report-repository-list.module';
import { reportRepositoryAdd } from './report-repository-add/report-repository-add.module';
import { reportRepositoryEdit } from './report-repository-edit/report-repository-edit.module';
import { reportRepositoryMain } from './report-repository-main/report-repository-main.module';
import { reportRepositoryDetails } from './report-repository-detail/report-repository-detail.module';

import { ReportRepositoryService } from './report-repository.service';
import './report-repository.scss';

export const reportRepository = angular
	.module('common.components.reportRepository', [
        reportRepositoryList,
        reportRepositoryAdd,
        reportRepositoryEdit,
        reportRepositoryMain,
        reportRepositoryDetails
    ])
    .service('ReportRepositoryService', ReportRepositoryService)
	.name;


// WEBPACK FOOTER //
// ./src/app/common/components/report-repository/report-repository.module.js